import axios from "axios";
import { apiConfig, EnumAPIKey } from "@/constants/app/api";
import { EnumEndpoints } from "@/constants/app/type";

/**
 * `baseAxios`'s response interceptor auto-unwraps any top-level `data` field that is an object/array
 * (see `src/lib/services/baseAxios.tsx`) — designed for APIs that envelope their payload as
 * `{ data: {...} }`. This endpoint's response is `{ data: string[], validity: string[], ... }`, where
 * `data` is itself one of the real fields, not an envelope — the shared interceptor would strip
 * `validity`/`parentGroupName`/`provider` and return only the `data` array. Bypass `baseAxios` here with
 * a plain request so the full shape reaches the reducer untouched.
 */
export const getEsimCatalogPublicFiltersService = async (body: Record<string, unknown>) => {
  const accessToken = typeof localStorage !== "undefined" ? localStorage.getItem("apiAccessToken") : null;
  const res = await axios.post(
    `${apiConfig[EnumAPIKey.API_BASE]}${EnumEndpoints.ESIM_CATALOG_PUBLIC_FILTERS}`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    },
  );
  return res.data;
};
